import querystring from 'query-string';
import { fetchPromo, generateFetchOpts } from 'api/editor';
import { POST, DELETE } from 'api/common';

/**
 * 編輯器取得點數池 info api https://app.clickup.com/t/866a852vm
 * @param   {string} sponsorId sponsorId
 * @param   {string} pointPoolUuid 點數池 Uuid
 * @return  {promise}
 */

export const getPointPoolInfoByEditor = ({ sponsorId, pointPoolUuid }) => {
    return fetchPromo(
        `/services/points/sponsors/${sponsorId}/pools/${pointPoolUuid}`,
        generateFetchOpts(),
        {
            dataKeys: 'data'
        }
    );
};

/**
 * @description https://app.clickup.com/t/866a9cwxz
 * @example  DELETE:`/services/sponsors/${sponsorId}/promotions/${promoId}/relations/point/pools/${pointPoolUuid}`
 * @method deletePointPoolRelatedApi 刪除獎品或活動與點數池關聯
 * @param   {string} sponsorId sponsor Id
 * @param   {string} promoId 活動 Id
 * @param   {string} pointPoolUuid 點數池 uuid
 * @param   {string} body api body ( 參考 https://app.clickup.com/t/866a9cwxz )
 * @return  {promise}
 */
export const deletePointPoolRelatedApi = ({ sponsorId, promoId, pointPoolUuid, body }) => {
    return fetchPromo(
        `/services/sponsors/${sponsorId}/promotions/${promoId}/relations/point/pools/${pointPoolUuid}`,
        generateFetchOpts({ method: DELETE, body })
    );
};

/**
 * @description https://app.clickup.com/t/866a8k36m
 * @example  POST:`/services/sponsors/${sponsorId}/promotions/${promoId}/relations/point/pools/${pointPoolUuid}`
 * @method createOrUpdatePointPoolRelated 將獎品或活動與點數池綁定關聯
 * @param   {string} sponsorId sponsor Id
 * @param   {string} promoId 活動 Id
 * @param   {string} pointPoolUuid 點數池 uuid
 * @param   {string} body api body ( 參考 https://app.clickup.com/36226806/v/dc/12hhqp-10720/12hhqp-24860 )
 * @return  {promise}
 */
export const createOrUpdatePointPoolRelated = ({ sponsorId, promoId, pointPoolUuid, body }) => {
    return fetchPromo(
        `/services/sponsors/${sponsorId}/promotions/${promoId}/relations/point/pools/${pointPoolUuid}`,
        generateFetchOpts({ method: POST, body })
    );
};

/**
 * @description https://app.clickup.com/t/866a84kvv
 * @example  GET:`/services/points/sponsors/${sponsorId}/pools?${qs}`
 * @method getPointPools 取得點數池列表
 * @param   {string} sponsorId sponsorId
 * @param   {string} status 搜尋條件：不帶，全搜尋且不含軟刪除的資料 / 帶入 all 會全搜尋但含軟刪除的資料 / 帶入 usable 會排除停用狀態，也不含軟刪除的資料
 * @param   {string} order 排序：不帶，使用 id，由小至大 / 帶入 updated 會依據更新時間，由最新至最舊
 * @param   {string} group 分類：帶入 status 會依據狀態分類
 * @return  {promise}
 */
export const getPointPools = ({ sponsorId, status, order, group }) => {
    const qs = querystring.stringify({ status, order, group });
    return fetchPromo(`/services/points/sponsors/${sponsorId}/pools?${qs}`, generateFetchOpts(), {
        dataKeys: 'data'
    });
};
